// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-container .error-container span{display:inline-block;background:#dc3545;color:white;padding:1rem}.checkbox-container .btn-disabled{cursor:not-allowed}\n", ""]);
// Exports
module.exports = exports;
